import type { ReactNode } from "react";
import "./PositionCell.scss";
import type { Position } from "@/pages/human-resources/time-management/business/Position.ts";
import ColorSwatch from "@/pages/human-resources/time-management/components/schedule-template/color-selector/ColorSwatch.tsx";
import classNames from "classnames";
import useScheduleViewStateDispatch from "@/pages/human-resources/time-management/model/schedule-view/useScheduleViewStateDispatch.ts";
import useScheduleViewState from "@/pages/human-resources/time-management/model/schedule-view/useScheduleViewState.ts";

interface Properties {
  position: Position;
}

export default function PositionCell(props: Properties): ReactNode {
  const {
    palette: { position: currentPosition },
  } = useScheduleViewState();
  const { callback } = useScheduleViewStateDispatch();
  const selected = props.position === currentPosition;
  const pickPosition = callback({
    type: "pickPosition",
    position: selected ? undefined : props.position,
  });

  return (
    <div
      className={classNames("position-cell", selected && "selected")}
      onClick={pickPosition}
    >
      <ColorSwatch color={props.position.color} />
      <div>{props.position.label}</div>
    </div>
  );
}
